const config = {
  SUPPORTED_STEPS: [
    "Choice",
    "EnterValue",
    "Picture",
    "SignDocument",
    "EnterText",
  ]
}
export default config



// WEBPACK FOOTER //
// ./src/config.js